import {KeyValuePipe} from "@angular/common";
import {ChangeDetectionStrategy, Component, inject} from "@angular/core";
import {MatButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {STORAGE_LANGUAGE_KEY} from "../../../services/constants";
import {BreakpointsDirective} from "../../../services/directives/breakpoints.directive";
import {LayoutService, ScreenSize} from "../../../services/layout/layout.service";
import {TranslateHelperService} from "../../../services/translate/translate-helper.service";

@Component({
    selector: "app-language-picker",
    imports: [
        MatButton,
        MatIcon,
        TranslatePipe,
        MatMenu,
        MatMenuTrigger,
        MatMenuItem,
        KeyValuePipe,
        BreakpointsDirective,
        MatTooltip,
    ],
    templateUrl: "./language-picker.component.html",
    styleUrl: "./language-picker.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LanguagePickerComponent {
    protected readonly ScreenSize = ScreenSize;

    private readonly translateService = inject(TranslateService);
    private readonly translateHelperService = inject(TranslateHelperService);
    protected readonly layoutService = inject(LayoutService);

    protected availableLanguages = new Map([
        ["de", {translationKey: "language.de"}],
        ["en", {translationKey: "language.en"}],
    ]);

    protected readonly language = this.translateHelperService.lang;

    protected selectLanguage(lang: string): void {
        localStorage.setItem(STORAGE_LANGUAGE_KEY, lang);
        this.translateService.use(lang);
    }
}
